import { render, staticRenderFns } from "./titleText.vue?vue&type=template&id=69d65f13&scoped=true&"
import script from "./titleText.vue?vue&type=script&lang=js&"
export * from "./titleText.vue?vue&type=script&lang=js&"
import style0 from "./titleText.vue?vue&type=style&index=0&id=69d65f13&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d65f13",
  null
  
)

export default component.exports